import React from 'react'
import PropTypes from 'prop-types'
import Button from '@mui/material/Button'
import { noop } from 'lodash'
import T from 'T'

const SaveButton = ({ onClick = noop, size = 'small', label = T.SAVE, ...rest }) => {
  return (
    <Button loadingPosition="center" onClick={onClick} variant="contained" color="primary" size={size} {...rest}>
      {label}
    </Button>
  )
}

SaveButton.propTypes = {
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  label: PropTypes.node,
}

export default SaveButton
